// Coach Experience section (Coach-Profile-Data): the merged coaching CV —
// TheSports resume stations + the coach's own Experience entries (own
// entries win, coachCareerData.js). Lives INSIDE Personal Info (Marin
// 2026-08-21: everything stays there — no separate Career tab). Station
// cards follow the Personal-Info Experience card markup (same borders/
// spacings) so the profile stays one visual system.
// Mobile (UI rule 1): cards are full-width flex rows that WRAP (stats line
// drops under the club line at 375px); nothing scrolls sideways.
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { buildCareerEntries } from "./coachCareerData";

// Collapsed list length (Marin 2026-08-21: „aufklappbar, nicht dass es
// endlos nach unten geht" — a few stations first, rest behind Show more).
const COLLAPSED_COUNT = 4;

const StatsLine = ({ e }) => {
  if (e.matches == null) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-2 text-[#646B7E] text-sm" style={{ fontVariantNumeric: "tabular-nums" }}>
      <span>{e.matches} matches</span>
      <span>·</span>
      <span>
        {e.win}W {e.draw}D {e.lose}L
      </span>
      {e.ppm ? (
        <>
          <span>·</span>
          <span>{e.ppm} pts/match</span>
        </>
      ) : null}
      {e.goalPpt ? (
        <>
          <span>·</span>
          <span>Goals {e.goalPpt}</span>
        </>
      ) : null}
    </div>
  );
};

const CoachCareer = ({ coach, title = "Experience" }) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const entries = buildCareerEntries(coach?.careerStations, coach?.experience);
  const visible = expanded ? entries : entries.slice(0, COLLAPSED_COUNT);
  const hiddenCount = entries.length - COLLAPSED_COUNT;

  return (
    <div className="space-y-8">
      <div>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-[#222A35] text-base font-bold">{title}</h2>
          {coach?.resume_url ? (
            <button
              onClick={() => window.open(coach.resume_url, "_blank")}
              className="text-[#2283FF] text-sm font-medium hover:underline"
            >
              Download Resume
            </button>
          ) : null}
        </div>
        <div className="space-y-4">
          {entries.length > 0 ? (
            visible.map((e) => (
              <div
                key={e.key}
                className="w-full flex flex-wrap items-center justify-between gap-3 p-4 bg-white border border-gray-100 rounded-lg"
              >
                <div className="flex items-center gap-4 min-w-0">
                  {e.clubLogo ? (
                    <img
                      src={e.clubLogo}
                      alt=""
                      className="w-10 h-10 object-contain flex-shrink-0"
                    />
                  ) : null}
                  <div className="flex flex-col min-w-0">
                    <h3
                      className={`text-[#000000] text-base font-bold ${
                        e.teamId ? "cursor-pointer hover:underline" : ""
                      }`}
                      onClick={
                        e.teamId
                          ? () => navigate(`/search/club/${e.teamId}`)
                          : undefined
                      }
                    >
                      {e.clubName}
                    </h3>
                    <p className="text-[#222A35] text-base font-medium">
                      {e.positionLabel}
                    </p>
                    <div className="flex flex-wrap items-center gap-2 text-[#646B7E] text-base">
                      {e.periodText ? <span>{e.periodText}</span> : null}
                      {e.place ? (
                        <>
                          <span>|</span>
                          <span>{e.place}</span>
                        </>
                      ) : null}
                    </div>
                    <StatsLine e={e} />
                  </div>
                </div>
                {e.source === "self" ? (
                  <div className="px-4 py-2 rounded-lg bg-[#D6DBEA4D] flex-shrink-0">
                    <span className="text-sm font-medium text-[#222A35]">
                      Own entry
                    </span>
                  </div>
                ) : null}
              </div>
            ))
          ) : (
            <div className="w-full p-8 bg-white border border-gray-100 rounded-lg text-center">
              <p className="text-[#646B7E] text-sm">
                No experience information available
              </p>
            </div>
          )}
          {hiddenCount > 0 && (
            <button
              type="button"
              onClick={() => setExpanded((v) => !v)}
              className="text-[#2283FF] text-sm font-medium hover:underline min-h-[44px] px-2"
            >
              {expanded ? "Show less" : `Show more (${hiddenCount})`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CoachCareer;
